export default {"src":"/_next/static/media/cartIcon.85b9c8ea.svg","height":100,"width":100};